import { useState } from 'react';
import {
  apiProductQualityRequirements,
  apiUpdateProductQualityRequirementItems,
  apiGetComplianceCustomOptions,
  apiExportQualityRequirement,
} from 'api';
import { callAction } from 'hooks/useData';

export const useData = () => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [qualityRequirements, setQualityRequirements] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [nameOptions, setNameOptions] = useState([]);
  const getQualityRequirements = async (productId, params) => {
    setFetchLoading(true);
    const res = await callAction(() =>
      apiProductQualityRequirements({ action: 'get', id: productId, data: params || {} })
    );
    setQualityRequirements(
      (res?.data?.data || []).map((obj) => {
        if (obj.items) {
          obj.items = obj.items.map((item) => {
            return { ...item };
          });
        }
        return obj;
      })
    );
    setFetchLoading(false);
  };
  const addQualityRequirement = async (productId, data, cb) => {
    const res = await callAction(() =>
      apiProductQualityRequirements({ action: 'add', id: productId, data })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const getTypeOptions = async (cb) => {
    const res = await callAction(() =>
      apiGetComplianceCustomOptions({ pageNo: 1, pageSize: 9999, type: 'productRequirementType' })
    );
    setTypeOptions(
      (res?.data?.data?.list || []).map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    if (cb) cb();
  };
  const getNameOptions = async (cb) => {
    const res = await callAction(() =>
      apiGetComplianceCustomOptions({ pageNo: 1, pageSize: 9999, type: 'productRequirementName' })
    );
    setNameOptions(
      (res?.data?.data?.list || []).map((obj) => ({
        value: obj.id,
        label: obj.name,
      }))
    );
    if (cb) cb();
  };
  const linkDataToRequirement = async (productId, requirementId, itemId, data, cb) => {
    const res = await callAction(() =>
      apiUpdateProductQualityRequirementItems({
        action: 'link',
        id: productId,
        data,
        qrId: requirementId,
        itemId,
      })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const deleteRequirementItem = async (productId, requirementId, itemId, cb) => {
    const res = await callAction(() =>
      apiUpdateProductQualityRequirementItems({
        action: 'delete',
        id: productId,
        data: {},
        qrId: requirementId,
        itemId,
      })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const completeRequirementItem = async (productId, requirementId, itemId, data, cb) => {
    const res = await callAction(() =>
      apiUpdateProductQualityRequirementItems({
        action: 'complete',
        id: productId,
        data,
        qrId: requirementId,
        itemId,
      })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const updateRequirementItem = async (productId, requirementId, itemId, data, cb) => {
    const res = await callAction(() =>
      apiUpdateProductQualityRequirementItems({
        action: 'edit_sub',
        id: productId,
        data,
        qrId: requirementId,
        itemId,
      })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const deleteRequirementSubItem = async (productId, requirementId, itemId, subKey, subId, cb) => {
    const res = await callAction(() =>
      apiUpdateProductQualityRequirementItems({
        action: 'delete_sub',
        id: productId,
        data: {},
        qrId: requirementId,
        itemId,
        subKey,
        subId,
      })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const duplicateRequirementItem = async (productId, requirementId, itemId, cb) => {
    const res = await callAction(() =>
      apiUpdateProductQualityRequirementItems({
        action: 'duplicate',
        id: productId,
        data: {},
        qrId: requirementId,
        itemId,
      })
    );
    if (cb) cb(res);
    if (res.success) {
      getQualityRequirements(productId);
    }
  };
  const exportQualityRequirement = async (productId, type, cb) => {
    try {
      const res = await apiExportQualityRequirement({
        productId,
        type,
      });
      if (cb) cb(res);
    } catch (error) {
      if (cb) cb(false);
    }
  };

  return {
    getQualityRequirements,
    qualityRequirements,
    getTypeOptions,
    typeOptions,
    getNameOptions,
    nameOptions,
    addQualityRequirement,
    fetchLoading,
    linkDataToRequirement,
    deleteRequirementItem,
    deleteRequirementSubItem,
    completeRequirementItem,
    updateRequirementItem,
    duplicateRequirementItem,
    exportQualityRequirement,
  };
};
